module.exports = __webpack_public_path__ + "media/Geigerzaehler.ddab72d2.mp3";